<script>
import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  authFdc,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

//import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "FDC",
    meta: [{ name: "description", content: "Ingreso" }]
  },
  components: { Layout },
  data() {
    return {
      email: null,
      password: null,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false
    };
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  computed: {
    ...mapState("authfdc", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    sending() {
      return this.$store ? this.$store.state.sending : false;
    }
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...authFdc,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.tryingToLogIn = true;
        const { email, password} = this;
        if (email && password)  {
          this.fdcLogin({ email, password })
        }
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Gestión Estacionamientos</h5>
                  <p>Mantén el control de total</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/ge_005.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >{{notification.message}}</div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group id="input-group-1" label="Correo electrónico" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Ingrese su correo electrónico"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                  :disabled="status.loggingIn"
                ></b-form-input>
                <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                  <span v-if="!$v.email.required">Correo electrónico es requerido.</span>
                  <span v-if="!$v.email.email">Ingrese una dirección correcta.</span>
                </div>
              </b-form-group>

              <b-form-group id="input-group-2" label="Contraseña" label-for="input-2">
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Ingrese su contraseña"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                  :disabled="status.loggingIn"
                >
                </b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >Contraseña es requerida.</div>
              </b-form-group>
              
              <div class="mt-3">
                <b-button type="submit" variant="primary" class="btn-block" :disabled="status.loggingIn">
                  Ingresar
                  <i class="bx bx-hourglass bx-spin font-size-16 align-middle mr-2" v-if="status.loggingIn" style="margin-left: 20px;"></i>
                </b-button>
              </div>
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock mr-1"></i> Olvidó su contraseña?
                </router-link>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            © {{new Date().getFullYear()}} Gestión Estacionamientos
            <br/>Desarrollado con <i class="mdi mdi-heart text-danger"></i> por <a href="https://fabricadecodigo.cl">Fábrica de Código</a>
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
